import { Spacing } from '@persona-id/design-tokens';
import { ComponentProps } from 'react';
import styled, { css } from 'styled-components';

import { COLORS } from 'dashboard/styles/variables';
import { FontWeight } from 'design-system/variables/text';
import IconCaretDown from 'images/icons/caret-down.svg';

interface TableBaseTHProps {
  canSort?: boolean;
  isSorted?: boolean;
  isDescending?: boolean;
  isSticky?: boolean;
}

const TableBaseTH = styled.div.attrs(() => ({ role: 'columnheader' }))<TableBaseTHProps>`
  display: table-cell;
  vertical-align: middle;

  background-color: ${({ theme }) => theme.color.background.secondary};
  padding: ${Spacing[3]} ${Spacing[4]};
  text-align: left;
  font-weight: ${FontWeight.Bold};
  white-space: nowrap;

  ${(props) =>
    props.isSticky
      ? css`
          position: sticky;
          top: 0;
          z-index: 1;
        `
      : css`
          position: relative;
        `}

  &:first-child {
    border-radius: ${({ theme }) =>
      `${theme.element.borderRadius} 0 0 ${theme.element.borderRadius}`};
  }

  &:last-child {
    border-radius: ${({ theme }) =>
      `0 ${theme.element.borderRadius} ${theme.element.borderRadius} 0`};
  }

  ${(props) => {
    if (!props.canSort) {
      return css`
        ${TableIconCaretDownTH} {
          display: none;
        }
      `;
    } else if (props.isSorted) {
      return css`
        cursor: pointer;
        ${TableIconCaretDownTH} {
          transform: translateY(-50%) scaleY(${props.isDescending ? 1 : -1});
        }
      `;
    } else {
      return css`
        cursor: pointer;
        ${TableIconCaretDownTH} {
          display: none;
        }

        &:hover > ${TableIconCaretDownTH} {
          display: inline;

          rect[fill],
          path[fill] {
            fill: ${({ theme }) => theme.color.text.disabled};
          }
        }
      `;
    }
  }};
`;

const TableIconContainerTH = styled('div')`
  display: grid;
  grid-template-columns: auto auto 1fr;
  grid-column-gap: ${Spacing[4]};
  align-items: center;
`;

const TableIconCaretDownTH = styled(IconCaretDown)`
  position: absolute;
  right: ${Spacing[4]};
  top: 50%;
  transform: translateY(-50%);

  rect[fill],
  path[fill] {
    fill: ${COLORS.black};
  }
`;

export default ({ children, ...props }: ComponentProps<typeof TableBaseTH>) => {
  if (props.canSort) {
    return (
      <TableBaseTH {...props}>
        <TableIconContainerTH>
          <span className='th__text'>{children}</span>
        </TableIconContainerTH>
        <TableIconCaretDownTH />
      </TableBaseTH>
    );
  } else {
    return (
      <TableBaseTH {...props}>
        <span className='th__text'>{children}</span>
      </TableBaseTH>
    );
  }
};
